import { render, staticRenderFns } from "./FullLandingMenu.vue?vue&type=template&id=637f214b&scoped=true&"
import script from "./FullLandingMenu.vue?vue&type=script&lang=js&"
export * from "./FullLandingMenu.vue?vue&type=script&lang=js&"
import style0 from "./FullLandingMenu.vue?vue&type=style&index=0&id=637f214b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f214b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637f214b')) {
      api.createRecord('637f214b', component.options)
    } else {
      api.reload('637f214b', component.options)
    }
    module.hot.accept("./FullLandingMenu.vue?vue&type=template&id=637f214b&scoped=true&", function () {
      api.rerender('637f214b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/elements/FullLandingMenu.vue"
export default component.exports